// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__8Aa3u","scheme":"css_scheme__APHBG","addColumn":"css_addColumn__LrRTl","addColumnInactive":"css_addColumnInactive__bCG9v","addButton":"css_addButton__nrqbr"};